module.exports = __webpack_public_path__ + "img/reg3PS-1.0ccc1996.jpg";